import React from "react";
import { dayMonth, plural } from "./geotabDashboard.js";
import { groupOffStops } from "./geotabDashboardDrivers.js";
import { fmtDuration, fmtTime } from "./geotabFormat.js";

// Onglet Hors plan de la fiche du chauffeur : un lieu par ligne, avec une barre proportionnelle à son temps.
export default function GeotabOffPlanDetails({ name, stops = [], days }) {
  const groups = groupOffStops(stops);
  const total = groups.reduce((sum, group) => sum + group.minutes, 0);
  const longest = Math.max(1, ...groups.map(group => group.minutes));
  return (
    <section aria-label={`Lieux hors plan · ${name}`} className="text-slate-700">
      <p className="mb-1.5 mt-0 text-[11.5px] tabular-nums">
        {`${fmtDuration(total)} au total · ${days ? fmtDuration(total / days) : "—"} par jour sur ${days} ${days > 1 ? "camions-jours" : "camion-jour"} · ${plural(stops.length, "visite")}`}
      </p>
      {groups.length ? groups.map(group => (
        <details key={group.key} className="group mb-1 rounded-[4px] border border-slate-200 last:mb-0">
          <summary className="flex cursor-pointer list-none items-center gap-2 px-2 py-1 text-[12px] hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40">
            <span aria-hidden="true" className="text-slate-500 group-open:rotate-90">▸</span>
            <span className="min-w-0 flex-1 break-words font-semibold">{group.name}{group.position && <span className="block text-[11px] font-normal text-slate-500">{group.position}</span>}</span>
            <span className="shrink-0 whitespace-nowrap text-[11px] text-slate-500">{plural(group.visits.length, "visite")}</span>
            <b className="w-14 shrink-0 whitespace-nowrap text-right tabular-nums">{fmtDuration(group.minutes)}</b>
            <span aria-hidden="true" className="hidden h-1.5 w-[200px] shrink-0 overflow-hidden rounded-[2px] bg-slate-100 sm:block">
              <i className="block h-full bg-[#c2410c]" style={{ width: `${(100 * group.minutes) / longest}%` }} /></span>
          </summary>
          <div className="overflow-x-auto border-t border-slate-100 px-2 pb-1">
            <table className="w-full min-w-0 text-left text-[11.5px] tabular-nums">
              <thead><tr>{["Date", "Chauffeur", "Camion", "Arrivée", "Départ", "Sur place"].map(label => <th key={label} className="px-1 py-1 text-[10px] font-semibold text-slate-500">{label}</th>)}</tr></thead>
              <tbody>{group.visits.map((visit, index) => (
                <tr key={`${visit.date}-${visit.truck_id}-${visit.arrival}-${index}`} className="border-t border-slate-100">
                  <td className="whitespace-nowrap px-1 py-0.5">{dayMonth(visit.date)}</td>
                  <td className="min-w-[90px] px-1 py-0.5">{visit.driver || "—"}</td>
                  <td className="px-1 py-0.5">{visit.truck}</td>
                  <td className="whitespace-nowrap px-1 py-0.5">{fmtTime(visit.arrival)}</td>
                  <td className="whitespace-nowrap px-1 py-0.5">{fmtTime(visit.departure)}</td>
                  <td className="whitespace-nowrap px-1 py-0.5 font-semibold">{fmtDuration(visit.minutes)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </details>
      )) : <p className="m-0 text-[12px] text-slate-500">Aucun arrêt hors plan compté sur cette période.</p>}
      <p className="mb-0 mt-1.5 text-[10.5px] text-slate-500">Dîner reconnu, changements de camion, chargements préchargés et travail ajouté reconnu exclus.</p>
    </section>
  );
}
